/** @jsxImportSource @emotion/react */

import React from 'react'
import PropTypes from 'prop-types'
import { positive, negative, neutral } from './styles'

export default function StyledNumber({ number }) {
  const getCss = () => {
    const value = Number(number)

    if (value < 0) return negative
    if (value === 0) return neutral
    return positive
  }

  return (
    <div style={getCss()}>
      {number}
    </div>
  )
}

StyledNumber.propTypes = {
  number: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

StyledNumber.defaultProps = {
  number: 0,
}
